import { przezmorzeApi } from "../../../api/api";
import { useQuery } from "@tanstack/react-query";

export interface PublicPackageByRegion {
  packageId: string;
  name: string;
  participantsNumber: number;
  dates: {
    from: string;
    to: string;
  };
}

export function useECommerceOffersByRegion(regionId: string, exceptPackagesIds: string[]) {
  const { data, isLoading } = useQuery({
    queryKey: ["public", "packages", "offers", regionId, exceptPackagesIds],
    queryFn: async ({ signal }) =>
      (
        await przezmorzeApi.get<PublicPackageByRegion[]>(`/public/packages/region/${regionId}/offers`, {
          signal,
          params: exceptPackagesIds.length > 0 ? { exceptPackages: exceptPackagesIds.join(",") } : undefined,
        })
      ).data,
  });
  return {
    data: data ?? [],
    isLoading,
  };
}
